/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import styled, { ITheme } from 'styled-components';

export const HeaderFrame = styled.div`
    display: block;
    background: transparent;
    padding-left: 2.6315789474vw;
    padding-right: 2.6315789474vw;
    min-height: 81px;
    position: fixed;
    top: 55px;
    transform: translate3d(0, 0, 0);
    transition: mdc-animation-exit-temporary(transform, 350ms);
    transition-duration: 200ms;
    will-change: transform;
    z-index: 100;
    width: 100%;

    .item-nav {
        &.active {
            color: #6b83ff;
        }
    }
    .box-left {
        display: flex;
        align-items: center;
        padding: 10px 0px 20px 0px;
        min-width: 270px;
        justify-content: space-around;
    }
    .list-nav {
        display: flex;
        gap: 24px;
        a {
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            color: #c5c8cc;
            font-family: 'Jost';
            :hover {
                color: #6b83ff;
            }
        }
    }
    .wrap-search {
        position: absolute;
        left: 175px;
        min-width: 335px;
        .ant-btn:hover {
            background: none !important;
            border: none !important;
            color: #fff !important;
            border-color: #40a9ff;
        }
        .ant-input:focus {
            border-color: #777e90 !important;
        }
        .ant-input:hover {
            border-color: #777e90 !important;
        }
    }
    .search-main {
        input {
            color: #fff;
            background: transparent !important;
            border: 1px solid #777e90;
            border-radius: 4px;
            padding-left: 10px;
            padding-right: 10px;
            height: 40px;
        }
        .ant-input-group-addon {
            height: 36px;
            background: transparent !important;
            border: 1px solid #777e90 !important;
            color: #fff !important;
            .ant-input-search-button {
                background: transparent !important;
                border: none !important;
                color: #fff !important;
            }
        }
    }

    .btn-join-wait-list {
        background: #6b83ff;
        width: 156px;
        margin-right: 12px;
        border: none;
        font-weight: 500;
        span {
            color: #fff;
        }
        :hover {
            background: rgb(39 209 116) !important;
            border: 1px solid rgb(39 209 116) !important;
            color: rgb(10, 9, 9) !important;
        }
    }
    .menu-mobile .btn-primary {
        color: ${({ theme }: { theme: ITheme }) => theme.text2};
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        min-height: 40px;
        padding: 0 5px;
        background: #1B1B1F !important;
        .ant-btn-round.ant-btn-lg {
            padding: 0;
        }
        #search-result{
            min-width: 17rem !important;
            margin-top: 0.5rem !important;
        }
        #wrap-header-search{
            height: 35px;
            width: 260px;
        }
        .wrap-search{
            position: unset;
            left: unset !important;
            min-width: 125px !important;
        }
        #style-wrapper{
            background: #bb9f9f29 !important;
            border-radius: unset;
            border: none;
        }
        .menu-mobile {
            height: 50px;
            min-height: 40px;
            display: flex !important;
            align-items: center;
            justify-content: space-between;
            .mode-dark-light {
                opacity: 0;
                width: 70px;
            }
            .logo {
                // height: 20px;
                padding-left: 10px;
                svg {
                    height: 100% !important;
                    margin-top: 8px;
                }
                a{
                    font-style: normal;
                    font-weight: 500;
                    font-size: 19px;
                    color: #fff;
                    font-family: 'Orbitron';
                }
            }
            .connect-mobile {
                min-height: 40px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .btn-network {
                    width: fit-content !important;
                    padding-left: 10px;
                    padding-right: 10px;
                    height: 40px;
                    margin-right: 12px;
                    background: transparent !important;
                    border: 1px solid #7773;
                }
                svg{
                    font-size: 25px;
                }

                .btn-menu-mobile {
                    background: none;
                    border: none;
                    height: 40px;
                    width: 40px;
                    // margin-left: 8px;

                    &:hover {
                        background: none !important;
                        border: none !important; 
                    }
                }
            }
        }
        .menu-desktop {
            display: none !important;
        }
    `}
    .menu-mobile {
        display: none;
    }
    .menu-desktop {
        height: 100%;
        min-height: 81px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
            // margin-left: -67px;
            a {
                font-style: normal;
                font-weight: 500;
                font-size: 2.2em;
                letter-spacing: -0.01em;
                color: #fff;
                font-family: 'Orbitron';
            }
            svg {
                margin-top: 15px;
            }
        }
        .drawer-menu {
            span {
                margin-left: 4px;
                color: ${({ theme }: { theme: ITheme }) => theme.text1};
            }
        }
        .right-header {
            position: relative;
            .position-right-header {
                position: absolute;
                right: 0;
                top: -20px;
            }
            .network {
                gap: 20px;
                flex: 1;
                display: flex;
                justify-content: flex-end;
                min-width: 750px;
                .btn-account {
                    margin-left: 12px;
                    font-size: 20px;
                    font-weight: 600;
                    text-transform: uppercase;
                    width: 40px !important;
                    /* border-radius: 28px; */
                    height: 40px;
                    padding-left: 10px;
                    padding-right: 10px;
                    background: #57ff6700;
                    border: 1px solid #7773;
                    color: #c5c8cc;
                    svg {
                        color: #ffffff8f;
                    }
                }
                .btn-network {
                    width: 120px;
                    color: ${({ theme }: { theme: ITheme }) => theme.text2};
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-left: 10px;
                    padding-right: 10px;
                    height: 40px;
                    margin-right: 12px;
                    background: transparent !important;
                    border: 1px solid ${({ theme }: { theme: ITheme }) => theme.dark3};
                }
                .btn-connect-wallet {
                    background: transparent !important;
                    border: 1px solid #7773 !important;
                }
                .btn-network ~ .ant-btn {
                    margin-left: 12px;
                }
                .btn-login {
                    max-width: 100px;
                    width: 100%;
                    margin-right: 12px;
                }
                .btn-gradient {
                    background: -webkit-linear-gradient(-75deg, #15b2f4 0%, #9546c2 50%, #fd7942 75%);
                    border: none;
                }
                .btn-round {
                    background: none;
                    border: 2px solid ${({ theme }: { theme: ITheme }) => theme.dark3};
                    width: 60px !important;
                    height: 40px;
                    margin-left: 8px;
                }
            }
        }
    }
`;
